"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
function ModelSizeSlider(props) {
    const { isScaleHintVisible, onValueChange, isMobile } = props;
    const [sliderValue, setSliderValue] = (0, react_1.useState)(50);
    const [sliderHintVisible, setSliderHintVisible] = (0, react_1.useState)(false);
    const onSliderThumbMouseDown = (0, react_1.useCallback)(() => {
        setSliderHintVisible(sliderValue > 40 && sliderValue < 60);
    }, [sliderValue]);
    const onSliderThumbMouseUp = (0, react_1.useCallback)(() => {
        setSliderHintVisible(false);
    }, []);
    const onSliderValueChange = (0, react_1.useCallback)((value) => {
        const newValue = value;
        setSliderValue(newValue);
        onSliderThumbMouseDown();
        onValueChange(newValue);
    }, [onSliderThumbMouseDown, onValueChange]);
    // It's not a mistake. In Productivity app we have iverted slider with big top icon and small bottom one
    // on mobile platforms we have regular (not inverted) slider with small left icon and big right one
    const IconEnd = isMobile ? SliderIconSmallMobile : SliderIconBig;
    const IconStart = isMobile ? SliderIconBigMobile : SliderIconSmall;
    return ((0, jsx_runtime_1.jsxs)(SliderContainer, { "$isMobile": !!isMobile, "data-e2e": 'ModelSizeSlider_SliderContainer', children: [(0, jsx_runtime_1.jsx)(IconEnd, { name: ui_1.Icons.Live_Mode_Slider_Skeleton, "data-e2e": 'ModelSizeSlider_IconEnd' }), (0, jsx_runtime_1.jsx)(StyledSlider, { "$isMobile": !!isMobile, defaultValue: 50, max: 100, invert: !isMobile, thumbClassName: "thumb", trackClassName: "track", orientation: isMobile ? 'horizontal' : 'vertical', onChange: onSliderValueChange, onBeforeChange: onSliderThumbMouseDown, onAfterChange: onSliderThumbMouseUp, "data-e2e": 'ModelSizeSlider_StyledSlider' }), (0, jsx_runtime_1.jsx)(IconStart, { name: ui_1.Icons.Live_Mode_Slider_Skeleton, "data-e2e": 'ModelSizeSlider_IconStart' }), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: sliderHintVisible && isScaleHintVisible, timeout: 200, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'ModelSizeSlider_CSSTransition', children: (0, jsx_runtime_1.jsx)(SliderHint, { "$isMobile": !!isMobile, "data-e2e": 'ModelSizeSlider_SliderHint', children: (0, i18n_1.Localized)(i18n_1.Strings.liveMode.scaleSliderHint) }) })] }));
}
exports.default = ModelSizeSlider;
const SliderContainer = styled_components_1.default.div `
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  ${props => props.$isMobile
    ? (0, styled_components_1.css) `
          width: 100%;
          height: 80px;
        `
    : (0, styled_components_1.css) `
          width: 60px;
          height: 250px;
          margin: 60px 10px;
        `};

  pointer-events: auto;
`;
const SliderIconBig = (0, styled_components_1.default)(ui_1.Icon) `
  position: absolute;
  top: -50px;
  left: 50%;

  width: 32px;
  height: 40px;

  transform: translateX(-50%);
`;
const SliderIconSmall = (0, styled_components_1.default)(ui_1.Icon) `
  position: absolute;
  bottom: -35px;
  left: 50%;

  width: 16px;
  height: 20px;

  transform: translateX(-50%);
`;
const SliderIconBigMobile = (0, styled_components_1.default)(ui_1.Icon) `
  position: relative;

  width: 45px;
  height: 50px;
  margin: auto 20px;
`;
const SliderIconSmallMobile = (0, styled_components_1.default)(ui_1.Icon) `
  position: relative;

  width: 25px;
  height: 30px;
  margin: auto 20px;
`;
const StyledSlider = (0, styled_components_1.default)(ui_1.Slider) `
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;

  ${props => props.$isMobile
    ? (0, styled_components_1.css) `
          height: 80px;
          margin: 0;
          width: 100%;
          overflow: hidden;
        `
    : (0, styled_components_1.css) `
          height: 100%;
        `}

  .track {
    ${props => props.$isMobile
    ? (0, styled_components_1.css) `
            width: 100%;
            height: 3px;
          `
    : (0, styled_components_1.css) `
            width: 3px;
            height: auto;
          `};

    margin: auto;

    background-color: ${props => props.theme.liveMode.background};
    border: solid 1px ${props => props.theme.heatheredGrey};
    border-radius: 4px;
  }

  &::before {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;

    display: block;
    width: 3px;
    height: 3px;

    background: white;
    border-radius: 50%;
    transform: translate(-50%, -50%);

    content: '';
  }
`;
const SliderHint = styled_components_1.default.div `
  position: absolute;

  ${props => props.$isMobile
    ? (0, styled_components_1.css) `
          top: -20%;
          right: auto;
          left: calc(50% - 76px);
        `
    : (0, styled_components_1.css) `
          top: calc(50% - 17px);
          right: 100%;
        `};

  display: flex;
  align-items: center;
  justify-content: center;

  width: 135px;
  height: 34px;

  color: ${props => props.theme.gray};
  font-weight: 300;
  font-size: 13px;

  background-color: ${props => props.theme.white};
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 ${props => props.theme.black_50};

  pointer-events: none;

  &.enter {
    transform: translateY(-20%);
    opacity: 0;
  }

  &.enter-active {
    transform: initial;
    opacity: 1;

    transition: all 0.15s ease-in-out;
  }

  &.exit {
    opacity: 1;
  }

  &.exit-active {
    transform: translateY(-20%);
    opacity: 0;

    transition: all 0.15s ease-in-out;
  }
`;
